export default __webpack_public_path__ + "static/media/no_files_to_download.359e049a.svg";